export const CONFIRMATION_MODALITIES = {
  PAID: 'paid',
  RESERVED: 'reserved',
  FACEBOOK: 'facebook'
} as const
